export var searchFilterRegexp = /search,.*/gi;
export var includeDiscontinuedFilterRegexp = /includeDiscontinued,(true|false)/gi;
